import React from 'react';
import { Box as MuiBox } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Primitive Box component
 * Styled version of MUI Box that respects the theme
 */
const Box = ({ children, ...props }) => {
  const theme = useTheme();

  return (
    <MuiBox
      {...props}
      sx={{
        ...props.sx,
      }}
    >
      {children}
    </MuiBox>
  );
};

export default Box;

